export default __webpack_public_path__ + "static/media/koro-sports.616f0322.png";